import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-redmine-reports',
  templateUrl: './redmine-reports.component.html',
  styleUrls: ['./redmine-reports.component.scss']
})
export class RedmineReportsComponent implements OnInit {
  issueForm: FormGroup;
  customFieldsForm: FormGroup;
  customFields = [];
  constructor(private http: HttpClient, private fb: FormBuilder) {}

  ngOnInit() {
    fetch(
      'https://task.megakit.pro/issues.json?key=b28e8a1eda065a870727efd8cb4741bcab9c3a37&cf_10=123',
      {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => {
        console.log('TCL: RedmineReportsComponent -> ngOnInit -> res', res);
      })
      .catch(err => {
        console.log('TCL: RedmineReportsComponent -> ngOnInit -> err', err);
      });

    this.http
      .get(
        'https://task.megakit.pro/custom_fields.json?key=b28e8a1eda065a870727efd8cb4741bcab9c3a37',
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        }
        /*   {
          issue: {
            project_id: 1,
            subject: 'Example',
            priority_id: 4
          }
         },*/
      )
      .subscribe(
        res => {
          this.customFields = res['custom_fields'];
          let formObj = {};
          this.customFields.forEach(field => {
            let validators = [];
            if (field.is_required) {
              validators.push(Validators.required),
                [field.default_value, validators];
            }
            formObj[field.id] = [field.default_value || '', validators];
          });

          this.customFieldsForm = this.fb.group(formObj);
       
        },
        err => {
          console.log(err);
        }
      );
    /**/

    this.issueForm = this.fb.group({
      subject: ['', Validators.required],
      description: ['']
    });
  }

  createIssue() {
    let customFormVal = this.customFieldsForm.getRawValue();
    let res = Object.keys(customFormVal).map(key => {
      return { id: key, value: customFormVal[key] };
    });

    let issue = {
      ...this.issueForm.value,
      project_id: 38,
      tracker_id: 7,
      status_id: 12,
      custom_fields: res
    };
    this.http
      .post(
        'https://task.megakit.pro/issues.json?key=b28e8a1eda065a870727efd8cb4741bcab9c3a37',
        { issue: issue }
      )
      .subscribe(
        res => {
          console.log('TCL: RedmineReportsComponent -> ngOnInit -> res', res);
        },
        err => {
          console.log(err);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/redmine-reports/redmine-reports.component.ts